import React, { Suspense, useState } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as LogoFooter } from './assets/logo_footer.svg';
import { FeedbackModal } from './components/mplat/Modals/FeedbackModal';
import { Spinner } from './components/mplat/Spinner';
import { WELCOME_ROUTES } from './const';
import { useAuth } from './hooks';


function AppFooter() {
    const auth = useAuth();

    const [accessRequested, setAccessRequested] = useState(false);
    const [showRegistration, setShowRegistration] = useState(false);

    const EmailValidationModal = React.lazy(() => import('./components/mplat/Modals/EmailValidationModal'));

    return <footer className="footer">
        {accessRequested && <FeedbackModal isOpen={accessRequested} onClose={() => setAccessRequested(false)} />}
        <Suspense fallback={<Spinner />}><EmailValidationModal isOpen={showRegistration} onClose={() => setShowRegistration(false)} /></Suspense>

        <div className="footer__inner">
            {(WELCOME_ROUTES.some((route) => location.pathname.startsWith(route)) || (location.pathname === '/' && !auth.user)) && <div className="footer__logo">
                <LogoFooter />
            </div>}
            <nav className="footer__nav">
                {/* <li><a href="#">О сервисе</a></li>
                <li><a href="#">Политика</a></li>
                <li><a href="#">Телеграм-бот</a></li> */}
                <ul>
                    <li>
                        <Link to="/about"><Trans>About</Trans></Link>
                    </li>
                    <li>
                        <a href="#feedback" onClick={(e) => {
                            e.preventDefault();
                            setAccessRequested(true);
                        }}>
                            <Trans>Feedback</Trans></a>
                    </li>
                    <li>
                        <Link to="/contacts"><Trans>Contacts</Trans></Link>
                    </li>
                    <li>
                        <Link to="/legal"><Trans>Legal</Trans></Link>
                    </li>
                    {/* <li>
                        <a href="https://t.me/MediabazaMarketplace_bot" target="_blank"><Trans>TGBOT</Trans></a>
                    </li> */}
                </ul>
            </nav>
            {!auth.user && <div className="footer__reg">
                <Link to="#register" className="btn" onClick={(e) => { e.preventDefault(); setShowRegistration(true); }}><Trans>Register</Trans></Link>
            </div>}
            <div className="footer__copy">© <Trans>Contacts msk-ix</Trans> {new Date().getFullYear()}</div>
        </div>
    </footer>
}

export default AppFooter;
